import { render, staticRenderFns } from "./NotificationsList.vue?vue&type=template&id=a649f188&scoped=true&"
import script from "./NotificationsList.vue?vue&type=script&lang=js&"
export * from "./NotificationsList.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsList.vue?vue&type=style&index=0&id=a649f188&prod&lang=scss&scoped=true&"
import style1 from "./NotificationsList.vue?vue&type=style&index=1&id=a649f188&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a649f188",
  null
  
)

export default component.exports